// shared settings for all stripe actions

import { API_URL } from 'config';


export const STRIPE_BASE_URL = `${API_URL}stripe/`;
